import { lazy, useEffect, useState } from 'react'
import { useSearchQuery } from '@queries/search/SearchQuery.js'
import { useOrgInfoStore } from '@store/common/useOrgInfoStore.js'
import SearchTabSection from '@sections/search/SearchTabSection.jsx'
import { useSearchTabStore } from '@store/search/useSearchTabStore.js'
import { useTranslation } from 'react-i18next'
const SearchInputResultSection = lazy(() => import('@sections/search/SearchInputResultSection.jsx'))

const getLocalData = () => {
  try {
    const raw = localStorage.getItem('search-data')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.searchData ?? null
  } catch (err) {
    console.warn('로컬스토리지 파싱 실패:', err)
    localStorage.removeItem('search-data')
    return null
  }
}

const SearchPage = () => {
  const { t } = useTranslation()
  const sections = useOrgInfoStore((s) => s.sections)
  const shouldUseAll = sections.includes('RANKING_ALL')
  const shouldUseExchange = sections.includes('RANKING_EXCHANGE')
  const shouldShowTabs = shouldUseAll && shouldUseExchange

  const tab = useSearchTabStore((s) => s.tab)
  const setSearchTab = useSearchTabStore((s) => s.setSearchTab)

  const TABS = [
    {
      label: t('search.tabs.all'),
      flag: 'all'
    },
    {
      label: t('search.tabs.exchange'),
      flag: 'exchange'
    }
  ]
  const [activeTab, setActiveTab] = useState(tab ?? 'all')
  const { data, isSuccess } = useSearchQuery()

  const [localData, setLocalData] = useState(getLocalData())

  // fetch 성공하면 로컬스토리지 업데이트
  useEffect(() => {
    if (isSuccess && data) {
      const payload = {
        updatedAt: Date.now(),
        data
      }
      try {
        localStorage.setItem('search-data', JSON.stringify(payload))
        setLocalData(data)
      } catch (err) {
        console.error('로컬스토리지 저장 실패:', err)
      }
    }
  }, [isSuccess, data])

  // 실제 사용할 데이터 (로컬스토리지에서 가져오기)
  const searchData = localData

  return (
    <section className={'flex flex-auto flex-col'}>
      <ul className={'flex w-full bg-white text-center'}>
        {shouldShowTabs && (
          <SearchTabSection
            tabs={TABS}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            setSearchTab={setSearchTab}
          />
        )}
      </ul>
      <SearchInputResultSection
        activeTab={activeTab}
        searchData={searchData}
        shouldUseAll={shouldUseAll}
        shouldUseExchange={shouldUseExchange}
      />
    </section>
  )
}

export default SearchPage
